'use strict';

var Cropper = require('cropperjs');

console.log('loading situationRecord module...');

var ngDragEventDirectives = {};

angular.forEach(
  'drag dragend dragenter dragexit dragleave dragover dragstart drop'.split(' '),
  function (eventName) {
    var directiveName = 'ng' + eventName.charAt(0).toUpperCase() + eventName.slice(1);

    ngDragEventDirectives[directiveName] = [
      '$parse',
      '$rootScope',
      function ($parse, $rootScope) {
        return {
          restrict: 'A',
          compile: function ($element, attr) {
            var fn = $parse(attr[directiveName], null, true);

            return function ngDragEventHandler(scope, element) {
              element.on(eventName, function (event) {
                var callback = function () {
                  fn(scope, { $event: event });
                };

                scope.$apply(callback);
              });
            };
          },
        };
      },
    ];
  }
);

const moduleName = 'situation-record';
angular.module(moduleName, [
  'ngDro',
  'ngResource',
  'ngDro-core',
  'checklist-model',
  'ngCsv',
  'angularFileUpload',
  'ngBase64Download',
  'ngQuill',
]);

global.ngDroModules.push(moduleName);

require('./node_modules/checklist-model/checklist-model.js');
require('./node_modules/ng-csv/build/ng-csv.min.js');
require('./node_modules/angular-file-upload/dist/angular-file-upload.min.js');
require('./node_modules/angular-base64-download/base64-download.js');

//******************************* CONTROLLERS ***********************************
angular.module(moduleName).controller('srIndexCtrl', require('./components/index/indexCtrl'));
angular
  .module(moduleName)
  .controller(
    'situationRecordMgmtCtrl',
    require('./components/situationRecord/situationRecordMgmtCtrl')
  );
angular
  .module(moduleName)
  .controller(
    'situationRecordSearchCtrl',
    require('./components/situationRecord/situationRecordSearchCtrl')
  );
angular
  .module(moduleName)
  .controller('sourceListCtrl', require('./components/source/sourceListCtrl'));
angular
  .module(moduleName)
  .controller('modalQuestCtrl', require('./components/modal/modalQuestCtrl'));
angular
  .module(moduleName)
  .controller('modalChannelsCtrl', require('./components/modal/modalChannelsCtrl'));
angular
  .module(moduleName)
  .controller('modalInputCtrl', require('./components/modal/modalInputCtrl'));
angular
  .module(moduleName)
  .controller('modalValidityPeriodsCtrl', require('./components/modal/modalValidityPeriodsCtrl'));
angular
  .module(moduleName)
  .controller(
    'situationRecordTemplateSearchCtrl',
    require('./components/situationRecordTemplate/situationRecordTemplateSearchCtrl')
  );
angular
  .module(moduleName)
  .controller('keywordsListCtrl', require('./components/keyword/keywordList/keywordListCtrl'));
angular
  .module(moduleName)
  .controller(
    'keywordsDetailCtrl',
    require('./components/keyword/keywordDetail/keywordDetailCtrl')
  );
angular
  .module(moduleName)
  .controller('channelsListCtrl', require('./components/channel/channelList/channelListCtrl'));
angular
  .module(moduleName)
  .controller(
    'channelsDetailCtrl',
    require('./components/channel/channelDetail/channelDetailCtrl')
  );
angular
  .module(moduleName)
  .constant('Cropper', Cropper)
  .directive(ngDragEventDirectives)
  .controller('publicCarouselCtrl', require('./components/publicCarousel/publicCarouselCtrl'));
angular
  .module(moduleName)
  .directive(ngDragEventDirectives)
  .controller('newsBullettinCtrl', require('./components/newsBullettin/newsBullettinCtrl'));

//******************************* SERVICES ***********************************
angular
  .module(moduleName)
  .service(
    'situationRecordService',
    require('./components/services/situationRecordServiceCtrl.js')
  );
angular
  .module(moduleName)
  .service('datex2EnumsService', require('./components/services/datex2EnumsService'));
angular.module(moduleName).service('sourceService', require('./components/services/sourceService'));
angular
  .module(moduleName)
  .service('situationRecordClass', require('./components/services/situationRecordClass'));
angular
  .module(moduleName)
  .service('errorHandlerService', require('./components/services/errorHandlerService'));
angular
  .module(moduleName)
  .service(
    'situationRecordTemplateService',
    require('./components/services/situationRecordTemplateService')
  );
angular.module(moduleName).service('utilsService', require('./components/services/utilsService'));
angular
  .module(moduleName)
  .service('keywordsService', require('./components/services/keywordsService.js'));
angular
  .module(moduleName)
  .service('channelsService', require('./components/services/channelsService.js'));

//******************************* DIRECTIVES ***********************************
angular
  .module(moduleName)
  .directive(
    'situationRecordNavBar',
    require('./components/directives/situationRecordNavBar/situationRecordNavBar')
  );
angular
  .module(moduleName)
  .directive(
    'situationRecordNavBarDetail',
    require('./components/directives/situationRecordNavBar/situationRecordNavBarDetail')
  );
//angular.module(moduleName).directive('mapLayerMenuDirective', require('./components/directives/mapLayerMenu/mapLayerMenuDirective'));
angular
  .module(moduleName)
  .directive(
    'situationRecordTable',
    require('./components/directives/situationRecordTable/situationRecordTable')
  );
angular
  .module(moduleName)
  .directive('csvExport', require('./components/directives/csvExport/csvExport'));

//******************************* FILTERS ***********************************
angular
  .module(moduleName)
  .filter('sourceTranscode', require('./components/filters/sourceTranscodeFilter.js'));
angular
  .module(moduleName)
  .filter('datex2EnumsTranscode', require('./components/filters/datex2EnumsTranscodeFilter.js'));
angular
  .module(moduleName)
  .filter('zonedDateTimeToDate', require('./components/filters/zonedDateTimeToDateFilter.js'));
angular.module(moduleName).filter('clazzIcon', require('./components/filters/clazzIconFilter.js'));
angular.module(moduleName).filter('clazzNode', require('./components/filters/clazzNodeFilter.js'));
angular
  .module(moduleName)
  .filter(
    'validityPeriodsToString',
    require('./components/filters/validityPeriodsToStringFilter.js')
  );
angular
  .module(moduleName)
  .filter('fileExtension', require('./components/filters/fileExtensionFilter.js'));
angular.module(moduleName).filter('fileName', require('./components/filters/fileNameFilter.js'));

//******************************* CONSTANTS ***********************************

//******************************* CONFIG ***********************************
angular.module(moduleName).config(require('./module-states'));
angular.module(moduleName).config(require('./module-translations'));

angular
  .module(moduleName)
  .run(function ($rootScope, $transitions, $state, MainViews, translateFilter) {
    console.log('situationRecord module running');

    //    //leggo la configurazione esterna del modulo
    //    if (!$rootScope.configs)
    //        $rootScope.configs = {};
    //    $rootScope.configs.ngDroAstralSituationRecordMainConfig = global.ngDroAstralSituationRecordMainConfig;

    //configurazione ngWYSIWYG editor

    //MODULE ngDro-AstralSituationRecord
    MainViews.register({
      title: translateFilter('AstralSituationRecord.dashboard'),
      state: 'situation-record-index',
      iconClass: 'fa fa-tachometer',
      order: 1,
      children: [],
    });
    MainViews.register({
      title: translateFilter('AstralSituationRecord.events'),

      iconClass: 'fa fa-exclamation-triangle',
      order: 2,
      children: [
        {
          title: translateFilter('AstralSituationRecord.search'),
          state: 'situation-record-search',
          iconClass: 'fa fa-search',
          order: 1,
        },
        {
          title: translateFilter('AstralSituationRecord.sources'),
          state: 'source-list',
          iconClass: 'fa fa-share-square-o',
          order: 2,
        },
        {
          title: translateFilter('AstralSituationRecord.templates'),
          state: 'situation-record-template-search',
          iconClass: 'fa fa-file',
          order: 3,
        },
        //            , {
        //                title: "CANCELLARE!!!",
        //                state: 'situation-record-template-list',
        //                iconClass: 'fa fa-alert',
        //                order: 4
        //            }
        {
          title: translateFilter('AstralSituationRecord.keywords'),
          state: 'situation-record-keyword-list',
          iconClass: 'fa fa-tags',
          order: 4,
        },
        {
          title: translateFilter('AstralSituationRecord.channels'),
          state: 'situation-record-channel-list',
          iconClass: 'fa fa-bullhorn',
          order: 5,
        },
      ],
    });
    MainViews.register({
      title: translateFilter('AstralSituationRecord.publicSite'),
      iconClass: 'fa fa-group',
      order: 3,
      children: [
        {
          title: translateFilter('AstralSituationRecord.carousel'),
          state: 'public-carousel',
          iconClass: 'fa fa-picture-o',
          order: 1,
        },
        {
          title: translateFilter('AstralSituationRecord.newsBullettin'),
          state: 'news-bullettin',
          iconClass: 'fa fa-newspaper-o',
          order: 2,
        },
      ],
    });

    //******************************************************************************************
    //****************************  GESTIONE TRANSIZIONE DI STATO   ****************************
    //******************************************************************************************
    $transitions.onSuccess({ to: '*' }, function ($state) {
      if ($state._treeChanges && $state._treeChanges.from && $state._treeChanges.from.length) {
        $rootScope.situationRecordPrevState =
          $state._treeChanges.from[$state._treeChanges.from.length - 1].state;
      }
    });
    $rootScope.back = function (params, options) {
      if ($rootScope.situationRecordPrevState && $rootScope.situationRecordPrevState.name) {
        if (!params) {
          params = $rootScope.situationRecordPrevState.params;
        }
        $state.go($rootScope.situationRecordPrevState.name, params, options);
      } else {
        $state.go('index');
      }
    };
  });



// WEBPACK FOOTER //
// ./src/modules/ngDro-AstralSituationRecord/module.js